import moment from 'moment';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import { useBackupCommon } from '@/views/utility/backup/BackupCommon.js';
import { MSConstant } from '@/commons/wildcards';
import { useContextStorage } from '@/composables/contextStorage/useContextStorage';
import {cloneDeep} from 'lodash';

/**
 * Thực hiện set context từ payload
 * @param {*} state 
 * @param {*} payload 
 * @returns 
 */
const setContext = (state, payload) => {

  state.TokenExpired = new Date().addSeconds(payload.TokenTimeout);
  state.Token = payload.Token;
  state.RefreshToken = payload.RefreshToken;
  state.User = payload.User;
  state.Context = payload.Context;
  state.Context.DeviceId = payload.Context.DeviceId;
  // Fallback MPLSubTenantId từ cookie x-subtenant-id nếu BE không trả về (root-tenant user hoặc field chưa set)
  if (!state.Context.MPLSubTenantId) {
    state.Context.MPLSubTenantId = commonFn.getCookie('x-subtenant-id') || null;
  }
  state.Permission = payload.Permission || null;
  state.IsAdmin = payload.IsAdmin;
  state.PostedDate =
    payload.Context.PostedDate && payload.Context.PostedDate.getFullYear() < new Date().getFullYear()
      ? payload.Context.PostedDate
      : new Date();
  state.FiscalStartDate = new Date(new Date().getFullYear(), 0, 1);
  state.DatabaseId = payload.Context.DatabaseId;
  state.TenantId = payload.Context.TenantId;
  state.BudgetCode = payload.Context.BudgetCode;
  state.NearExpiredDate = payload.Context.NearExpiredDate;
  state.NumberOfDayNearExpired = payload.Context.NumberOfDayNearExpired;
  state.NumberOfDayExpired = payload.Context.NumberOfDayExpired;
  state.SubscriberNo = payload.Context.SubscriberNo;
  state.Context.ShowWarningDate = payload.Context.ShowWarningDate;
  state.Context.ShowWarningDateTop = payload.Context.ShowWarningDateTop;
  state.Context.ShowWarningDateTopClient = payload.Context.ShowWarningDateTop;
  state.StatusCircular = payload.Context.StatusCircular;
  state.StatusCircularTT76 = payload.Context.StatusCircularTT76;
  state.HasLicenseFromSuman = payload.Context.HasLicenseFromSuman;
  return state;
}

export default {
  resetState(state) {
    let x = 1;
    //Object.assign(state, defaultConfigState);
  },
  updateConfig: function (state, payload) {
    let currentDate = moment(payload.CurrentDate).toDate();
    state.ConfigInfo = {
      ...state.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  updateCulture: function (state, payload) {
    state.Context.Culture = payload;
  },
  /**
   * Cập nhật tab id khi mở page
   * @param {*} state
   * @param {*} payload
   */
  syncTabId(state, payload) {
    state.syncTabId = payload;
  },
  /**
   * Cập nhật lại thông tin token và refresh token khi thực hiện refresh token
   * NHANH3 07.02.2025
   */
  refreshToken(state, payload) { 
    if (payload && payload.AccessToken && payload.TokenTimeout && payload.NewRefreshToken) {  
      state.TokenExpired = new Date().addSeconds(payload.TokenTimeout);
      state.Token = payload.AccessToken;
      state.RefreshToken = payload.NewRefreshToken;
    }
  },
  updateToken(state, payload) {
    if (payload.Context.UseMutilTabs) {
      //#region Compatible with old version
      const { setSourceContextStorage } = useContextStorage();
      const isCompatible = true;
      const newState = setContext(cloneDeep(state), payload);
      setSourceContextStorage(newState, isCompatible);
      //#endregion
    } else {
      //Nếu có sự thay đổi token thì cần thông báo cho các tab khác để reload trang
      if (state.Token !== payload.Token) {
        localStorage.setItem(window.syncKeyToken, state.syncTabId);
      }
    }
    // Luôn cập nhật state hiện tại (kể cả khi UseMutilTabs = true) để tránh trường hợp
    // các API gọi ngay sau khi login (VD: accountingObjectAPI.updateUsedRegularly, router guard)
    // đọc phải state.Token/RefreshToken = null do nhánh trên chỉ ghi vào storage của bản clone
    // → auth.isAuthenticated() false → lỗi "No token or refresh token" / "Invalid navigation guard"
    setContext(state, payload);
    commonFn.removeLocalStorage('mimosa_show_notify_update_tt24');
  },
  // restoreContext(state) {
  //   state.Token = commonFn.getLocalStorage("Token");
  //   state.User = JSON.parse(commonFn.getLocalStorage("User"));
  //   state.Context = JSON.parse(commonFn.getLocalStorage("Context"));
  // },
  updateLogout: function (state, payload) {
    state.Token = null;
    state.Context = null;
    state.TokenExpired = null;
    state.User = null;
    state.Permission = null;

    //xóa all storage
    sessionStorage.clear();
    //Chỉ thực hiện xóa key token, còn lại giữ nguyên
    localStorage.removeItem('mimosa_vuex');
    // Xóa thông tin đăng nhập dvc
    localStorage.removeItem('DVCToken');
    localStorage.removeItem('DVCTokenExpire');
    localStorage.removeItem('DVCUser');
    localStorage.removeItem('DVCRole');
  },

  updateLoading(state, payload) {
    state.Loading = payload;
  },
  updatePermission(state, payload) {
    state.Permission = payload;
  },
  updateCreateDataProcess(state, payload) {
    state.CreateDataProcess = payload;
  },
  updateBackUpSC(state, payload) {
    state.BackUpSuccess = payload;
  },

  updateStatusTT23(state, payload) {
    state.Context.StatusCircular = payload;
  },

  updateStatusTT76(state, payload) {
    state.Context.StatusCircularTT76 = payload;
  },
  updateIsCheckOverUser(state, payload) {
    state.Context.IsCheckOverUser = payload;
  },

  /**
   * clear thông tin phiên đăng nhập
   */
  removeToken(state) {
    state.Token = null;
    state.Context = null;
    state.TokenExpired = null;
    state.User = null;
    state.Permission = null;

    // //ghi context vào localstorage
    // commonFn.removeLocalStorage("TokenExpired");
    // commonFn.removeLocalStorage("Token");
    // commonFn.removeLocalStorage("Context");
    // commonFn.removeLocalStorage("User");
  },
  updateLeftMenuCollapse(state, payload) {
    state.LeftMenuCollapse = payload;
  },
  completeGetting(state) {
    let getting = {
      GettingStarted: true,
      SeenGetting: true,
    };
    state.GettingStarted = getting;
    commonFn.setLocalStorage('GettingStarted', JSON.stringify(getting));
    window._getting = getting;
  },
  /**
   * Cập nhật postedDate
   * @param {*} state
   * @param {*} payload
   * tbngoc 28/07/2022
   */
  updatePostedDate(state, payload) {
    if (payload && payload.PostedDate) {
      state.PostedDate = payload.PostedDate;
    }
  },
  /**
   * Cập nhật ngày bắt đầu hạch toán
   * @param {*} state
   * @param {*} payload
   * tbngoc 18.08.2022
   */
  updateFiscalStartDate(state, payload) {
    if (payload && payload.FromDate && payload.dbStartDate) {
      if (payload.FromDate.getFullYear() > payload.dbStartDate.getFullYear()) {
        state.FiscalStartDate = new Date(payload.FromDate.getFullYear(), 0, 1);
      } else {
        state.FiscalStartDate = payload.dbStartDate;
      }
    }
  },
  /**
   * Cập nhật client_id vào context
   * @param {*} state
   * @param {*} clientId
   * NCPHUOC 16/08/2022
   */
  updateMimosaSessionId(state, clientId) {
    if (clientId) {
      state.MimosaSessionId = clientId;
    }
  },

  /**
   * update tab id vào state sử dụng phân biệt giữa các tab của người dùng websocket
   * id này sẽ được thay đổi khi người dùng mở tab mới hoặc F5 lại trình duyệt hiện tại
   * @param {*} state state
   * @param {*} id uuid hiện tại
   * HTHIEP 12.07.2023
   */
  updateTabId(state, id) {
    if (id) {
      state.TabId = id;
    }
  },

  /**
   * Cập nhật trạng thái disabled topnav khi chuyển đổi
   * @param {*} state
   * @param {*} payload
   * TPNAM 22/11/2022
   */
  changeDisabledConvert(state, payload) {
    state.IsDisabledConvert = payload;

    // Nếu đã bật loading thì cứ mặc định tầm 15p là tắt đi
    // if (payload == true) {
    //   setTimeout(() => {
    //     state.IsDisabledConvert = false;
    //   }, window._timeOffLoadingConvert);
    // }
  },

  /**
   * Cập nhật trạng thái disabled topnav khi db đang sao lưu, phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 10.2.2023
   */
  changeDisabledBusyDatabase(state, payload) {
    state.IsDisabledBusyDatabase = payload;
  },

  /**
   * Cập nhật tất cả các database đang convert
   * @param {*} state
   * @param {*} payload array
   * TPNAM 22/11/2022
   * nvtoan2 08/12/2022: Dùng được cả trong trường hợp push và gán
   */
  insertCacheTimeConvert(state, payload) {
    if (!state.LastTimeConvert.some(x => x.database_id == payload.database_id)) {
      state.LastTimeConvert.push(payload);
    }
  },
  /**
   * Xóa cache thời gian lần cuối convert
   * @param {*} state
   * @param {*} payload
   * nvtoan2 14/02/2022
   */
  removeCacheTimeConvert(state, payload) {
    state.LastTimeConvert = state.LastTimeConvert.filter(x => !payload.some(y => y.database_id == x.database_id));
  },

  /**
   * Cập nhật database đang convert trong tk
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 30/12/2022
   */
  insertDatabaseConverting(state, payload) {
    state.DatabaseConverting = state.DatabaseConverting.concat(
      payload.filter(item => state.DatabaseConverting.indexOf(item) < 0),
    );
  },

  /**
   * progress convert
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 19/04/2023
   */
  updateConvertProgress(state, payload) {
    let index = state.ConvertProgress.findIndex(x => x.DatabaseId == payload?.DatabaseId);
    if (index >= 0) {
      state.ConvertProgress[index] = payload;
    } else {
      state.ConvertProgress.push(payload);
    }
  },

  /**
   * Xóa progress convert
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 24/04/2023
   */
  removeConvertProgress(state, payload) {
    state.ConvertProgress = state.ConvertProgress.filter(x => !payload.some(y => y.database_id == x.DatabaseId));
  },

  /**
   * Cập nhật tất cả các database đang convert
   * @param {*} state
   * @param {*} payload array
   * nvtoan2 08/12/2022
   */
  updateDatabaseConverting(state, payload) {
    state.DatabaseConverting = payload?.clone();
  },

  /**
   * Cập nhật convert queue mới nhất
   * @param {*} state
   * @param {*} payload
   * nvtoan2 11/05/2023
   */
  updateLastConvertQueue(state, payload) {
    state.LastConvertQueue = { ...payload };
  },

  /**
   * Xóa database convert
   * @param {*} state
   * @param {*} payload
   * NVTOAN2 30/12/2022
   */
  removeDatabaseConverting(state, payload) {
    state.DatabaseConverting = state.DatabaseConverting.filter(x => !payload.includes(x));
  },

  /**
   * Cập nhật tất cả các database convert bị lỗi
   * @param {*} state
   * @param {*} payload array
   * nvtoan2 19/12/2022
   */
  updateDatabaseConvertError(state, payload) {
    state.DatabaseConvertError = payload?.clone();
  },

  /**
   * Cập nhật database trong đơn vị
   * @param {*} context
   * @param {*} payload
   * nvtoan2 07/12/2022
   */
  updateTenantDatabases(state, payload) {
    state.TenantDatabases = payload.clone();
  },

  /**
   * Cập nhật lại biến để show popup
   * @param {*} state
   * @param {*} payload
   * NTLOC 25.11.2022
   */
  changeShowWarningDate(state, payload) {
    state.Context.ShowWarningDate = false;
  },

  /**
   * Cập nhật lại biến để show noti top
   * @param {*} state
   * @param {*} payload
   */
  changeShowWarningDateTop(state, payload) {
    state.Context.ShowWarningDateTop = payload;
  },

  changeShowWarningDateTopClient(state, payload) {
    state.Context.ShowWarningDateTopClient = payload;
  },

  /**
   * Cập nhật lại biến để show popup cảnh báo hết hạn thanh toán
   * @param {*} state
   * @param {*} payload
   * nmtuan4 1.6.2023
   */
  changeShowWarningExtendExpired(state, payload) {
    state.Context.WarningExtendExpired = false;
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  insertDatabaseRestoring(state, payload) {
    if (Array.isArray(payload)) {
      state.DatabaseRestoring = state.DatabaseRestoring.concat(payload);
      return;
    }
    if (state.Context.DatabaseId == payload.database_id) {
      state.IsDisabledBusyDatabase = true;
      // popupUtil.show('RestoreProcess');
    }
    state.DatabaseRestoring.push(payload);
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  updateDatabaseRestoring(state, payload) {
    state.DatabaseRestoring = payload;
  },

  /**
   * Loại bỏ database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  removeDatabaseRestoring(state, payload) {
    state.DatabaseRestoring = state.DatabaseRestoring.filter(x => x.database_id != payload.database_id);
    const { afterRestoreSuccess } = useBackupCommon();
    afterRestoreSuccess(payload);
    if (state.Context.DatabaseId == payload.database_id) {
      state.IsDisabledBusyDatabase = false;
    }
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   * ntloc 25/05/2023: case thêm trường hợp sao lưu tt23
   * nvtoan2 26/09/2023: Nếu là backup từ chuyển đổi thì k hiện popup lên
   */
  insertDatabaseBackuping(state, payload) {
    if (Array.isArray(payload)) {
      state.DatabaseBackuping = state.DatabaseBackuping.concat(payload);
      return;
    }

    let backupForm = 'BackupRestore';

    if (payload.type == MSConstant.BackupType.Store) {
      backupForm = 'StorageForm';
    }

    if (
      state.Context.DatabaseId == payload.database_id &&
      (payload.circular != 'tt23' || payload.circular == undefined) &&
      !state.DatabaseConverting.some(x => x == state.Context.DatabaseId)
    ) {
      popupUtil.show(backupForm, {
        backuping: true,
        database: {
          database_id: payload.database_id,
          database_name: payload.database_name,
          backup_database_name: payload.backup_database_name,
        },
      });
      state.IsDisabledBusyDatabase = true;
    }
    state.DatabaseBackuping.push(payload);
  },

  /**
   * Cập nhật database đang sao lưu
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  updatePercentDatabaseBackuping(state, payload) {
    let database = state.DatabaseBackuping?.find(x => x.database_id == payload.database_id);

    if (database) {
      database.current_percent = payload.current_percent;
    }
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  updatePercentDatabaseRestoring(state, payload) {
    let database = state.DatabaseRestoring?.find(x => x.database_id == payload.database_id);

    if (database) {
      database.current_percent = payload.current_percent;
    }
  },

  /**
   * Loại bỏ database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  removeDatabaseBackuping(state, payload) {
    state.DatabaseBackuping = state.DatabaseBackuping.filter(x => x.database_id != payload.database_id);
    const { afterBackup } = useBackupCommon();
    afterBackup(payload);
    if (state.Context.DatabaseId == payload.database_id) {
      popupUtil.hide('BackupRestore');
      popupUtil.hide('StorageForm');
      state.IsDisabledBusyDatabase = false;
    }
  },

  /**
   * Cập nhật database đang phục hồi
   * @param {*} state
   * @param {*} payload
   * nmtuan4 01.02.2023
   */
  updateDatabaseBackuping(state, payload) {
    state.DatabaseBackuping = payload;
  },

  /**
   * Đánh dấu xem báo cáo từ phần hệ nào
   * dqdat1 15/05/2023
   */
  updateReportGroupId(state, groupId) {
    state.GroupId = groupId;
  },

  /**
   * Cập nhật tiến trình sao chép dữ liệu (Lưu object bao gồm nhiều thông tin: phần trăm sao chép, thông tin DL gốc, thông tin DL đích)
   * @param {*} context
   * @param {*} payload
   * dtnga3 (06.06.2023)
   */
  updateCopyDataProgress(state, payload) {
    let index = state.CopyDataProgress.findIndex(x => x.ToDatabaseId == payload?.ToDatabaseId);
    if (index >= 0) {
      state.CopyDataProgress[index] = payload;
    } else {
      state.CopyDataProgress.push(payload);
    }
  },

  /**
   * Thêm đánh dấu dữ liệu đang sao chép dữ liệu (chỉ lưu database_id của DL đang sao chép)
   * @param {*} context
   * @param {*} payload
   * dtnga3 (06.06.2023)
   */
  insertDatabaseCopyData(state, payload) {
    state.DatabaseCopyData = state.DatabaseCopyData.concat(
      payload.filter(item => state.DatabaseCopyData.indexOf(item) < 0),
    );
  },

  /**
   * Cập nhật kết quả sắp xếp số chứng từ
   * @param {*} state
   * @param {*} payload
   * dtnga3 (28.11.2023)
   */
  updateSortRefNoResult(state, payload) {
    let index = state.SortRefNoResult.findIndex(x => x.process_id == payload?.process_id);
    if (index >= 0) {
      state.SortRefNoResult[index] = payload;
    } else {
      state.SortRefNoResult.push(payload);
    }
  },

  /**
   * Xóa kết quả sắp xếp số chứng từ
   * @param {*} state
   * @param {*} payload
   * dtnga3 (28.11.2023)
   */
  removeSortRefNoResult(state, processIds) {
    state.SortRefNoResult = state.SortRefNoResult.filter(x => !processIds.some(id => id == x.process_id));
  },

  /**
   * Cập nhật mảng đánh dấu db đang sao chép
   * @param {*} state
   * @param {*} payload
   * dtnga3 (09.06.2023)
   */
  updateDatabaseCopyData(state, payload) {
    state.DatabaseCopyData = payload?.clone();
  },

  /**
   * Xóa progress sao chép
   * @param {*} state
   * @param {*} payload
   * dtnga3 (08.06.2023)
   */
  removeCopyDataProgress(state, payload) {
    state.CopyDataProgress = state.CopyDataProgress.filter(x => !payload.some(y => y.ToDatabaseId == x.ToDatabaseId));
  },

  /**
   * xóa các database đang sao chép
   * @param {*} state
   * @param {*} payload array : mảng database_id đã hoàn thành việc sao chép
   * dtnga3 (08.06.2023)
   */
  removeDatabaseCopyData(state, payload) {
    state.DatabaseCopyData = state.DatabaseCopyData.filter(x => !payload.includes(x));
  },

  /*
   * Cập nhật trạng thái gia hạn thành công
   * nmtuan4 10.7.2023
   */
  updateRenewalSuccess(state, payload) {
    state.Context.IsRenewalSuccess = payload;
  },

  /**
   * Cập nhât lại giá trị trong context
   * @param {*} state
   * @param {*} payload
   * ptthuy2 27.07.2023
   */
  updateValue(state, payload) {
    state.Context[payload.field] = payload.value;
  },
  /*
   * Cập nhật trạng thái phóng to tính năng mới
   * TPNAM 13.09.2023
   */
  updateNewFeatureZoom(state, payload) {
    state.NewFeatureZoom = payload;
  },

  updateHelpSettlemenZoom(state, payload) {
    state.HelpSettlemenZoom = payload;
  },
  /*
   * Cập nhật version tính năng mới
   * TPNAM 13.09.2023
   */
  updateVersionNewFeature(state, payload) {
    state.VersionNewFeature = payload;
  },

  /**
   * Cập nhật trạng thái có thông báo sự cố bảo trì trên thanh header không?
   * NVTUAN1 23.05.2024
   */
  updateMISANotifyHeader(state, payload) {
    state.MISANotifyHeader = payload;
  },

  /*
   * Cập nhật trạng thái thỏa thuận mua hàng
   * nthien4
   */
  updateMisaAgreementPurchase(state, payload) {
    state.MISAAgreementPurchase = payload;
  },
  /*
   * Cập nhật trạng thái có đè lên chatbot không
   * TPNAM 13.09.2023
   */
  updateIsPressChatbot(state, payload) {
    state.IsPressChatbot = payload;
  },
};
